import React, { useState, useEffect } from 'react';
import BookingButton from './BookingButton';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-2' : 'bg-transparent py-4'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => window.scrollTo(0, 0)}>
            <img 
              src="https://i.postimg.cc/zGWWzkp3/logohce-Converted.png" 
              alt="Hill Ear Care" 
              className="h-12 md:h-16 w-auto object-contain"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('pricing')} className="text-gray-700 hover:text-rose-gold font-medium transition-colors">Pricing</button>
            <button onClick={() => scrollToSection('gallery')} className="text-gray-700 hover:text-rose-gold font-medium transition-colors">Gallery</button>
            <button onClick={() => scrollToSection('reviews')} className="text-gray-700 hover:text-rose-gold font-medium transition-colors">Reviews</button>
            <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-rose-gold font-medium transition-colors">FAQ</button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-rose-gold font-medium transition-colors">Contact</button>
            <BookingButton text="Book Now" variant={isScrolled ? "primary" : "primary"} />
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-700 hover:text-rose-gold p-2"
            >
              <SafeIcon icon={isMobileMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} className="text-2xl" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t border-gray-100 overflow-hidden"
          >
            <div className="px-4 pt-2 pb-6 space-y-2 flex flex-col items-center">
              <button onClick={() => scrollToSection('pricing')} className="block px-3 py-2 text-gray-700 font-medium hover:text-rose-gold w-full text-center">Pricing</button>
              <button onClick={() => scrollToSection('gallery')} className="block px-3 py-2 text-gray-700 font-medium hover:text-rose-gold w-full text-center">Gallery</button>
              <button onClick={() => scrollToSection('reviews')} className="block px-3 py-2 text-gray-700 font-medium hover:text-rose-gold w-full text-center">Reviews</button>
              <button onClick={() => scrollToSection('faq')} className="block px-3 py-2 text-gray-700 font-medium hover:text-rose-gold w-full text-center">FAQ</button>
              <button onClick={() => scrollToSection('contact')} className="block px-3 py-2 text-gray-700 font-medium hover:text-rose-gold w-full text-center">Contact</button>
              <div className="pt-2">
                <BookingButton text="Book Now" />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;